import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-793b72b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#3B3B3B",
    "fill-opacity": ".9",
    d: "M10 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#00451D",
    "fill-opacity": ".9",
    d: "M15.946 15.334C15.684 13.265 14.209 12 11.944 12H8.056c-2.265 0-3.74 1.265-4.001 3.334A7.97 7.97 0 0 0 10 18a7.975 7.975 0 0 0 5.946-2.666ZM10 4c-1.629 0-3 .969-3 3 0 1.155.664 4 3 4 2.143 0 3-2.845 3-4 0-1.906-1.543-3-3-3Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#7AD200",
    d: "M8 7c0-1.74 1.253-2 2-2 .969 0 2 .701 2 2 0 .723-.602 3-2 3-1.652 0-2-2.507-2-3Zm3.944 6H8.056C6.222 13 5 14 5 16v.235A7.954 7.954 0 0 0 10 18a7.954 7.954 0 0 0 5-1.765V16c0-2-1.222-3-3.056-3Z"
  })
], -1))
const _hoisted_2 = { id: "idps" }
const _hoisted_3 = { class: "idp p-inputgroup" }
const _hoisted_4 = { class: "flex justify-content-between my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "session.login-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_Button, { class: "p-button-text p-button-rounded" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ], true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.isDisplaingIDPs,
      position: "topright",
      header: "Identity Provider",
      closable: false,
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              placeholder: "https://your.idp",
              type: "text",
              modelValue: _ctx.idp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.idp) = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.session.login(_ctx.idp, _ctx.redirect_uri)), ["enter"]))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              severity: "secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.session.login(_ctx.idp, _ctx.redirect_uri)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" >")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Button, {
            class: "idp",
            severity: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {
          _ctx.idp = 'https://solid.dev.datev.de';
          _ctx.session.login(_ctx.idp, _ctx.redirect_uri);
          _ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" https://solid.dev.datev.de ")
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "idp",
            severity: "secondary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {
          _ctx.idp = 'https://solidcommunity.net';
          _ctx.session.login(_ctx.idp, _ctx.redirect_uri);
          _ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" https://solidcommunity.net ")
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "idp",
            severity: "secondary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {
          _ctx.idp = 'https://solidweb.org';
          _ctx.session.login(_ctx.idp, _ctx.redirect_uri);
          _ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" https://solidweb.org ")
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "idp",
            severity: "secondary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {
          _ctx.idp = 'https://solidweb.me';
          _ctx.session.login(_ctx.idp, _ctx.redirect_uri);
          _ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" https://solidweb.me ")
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "idp",
            severity: "secondary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => {
          _ctx.idp = 'https://inrupt.net';
          _ctx.session.login(_ctx.idp, _ctx.redirect_uri);
          _ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(" https://inrupt.net ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            label: "Get a Pod!",
            severity: "secondary",
            onClick: _ctx.GetAPod
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "close",
            icon: "pi pi-times",
            iconPos: "right",
            severity: "secondary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDisplaingIDPs = !_ctx.isDisplaingIDPs))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}